<template>
  <CustomDialog
    :dialog-title="titleText"
    :has-footer="false"
    :has-exit-button="true"
    :footer-custom-style="{ display: 'none' }"
    max-width="480px"
    min-width="480px"
    :body-custom-style="{ padding: '0px' }"
    @cancel="emit('close')"
  >
    <div class="flex flex-col px-5">
      <div class="pt-6 pb-6">
        <p class="text-slate-600 text-sm font-medium">
          {{ descriptionText }}
          <a
            href="#"
            class="text-secondary-700 underline hover:text-secondary-800 transition-colors focus:outline-none"
            @click.prevent="manageClick"
            >{{ cookieSettingsLinkText }}</a
          >
        </p>
      </div>
      <div class="flex flex-col gap-2 pt-4 pb-4">
        <PrimaryButton class="w-full" @on-click="emit('confirmChat')">
          <div class="flex items-center justify-center gap-1">
            <Icon name="material-symbols:forum-outline" size="1.25rem" />
            <p>{{ confirmBtnText }}</p>
          </div>
        </PrimaryButton>
        <PrimaryButton
          variant="primary-ghost"
          class="w-fit mx-auto text-secondary-700 underline underline-offset-2 hover:text-secondary-800"
          @on-click="emit('declineChat')"
        >
          {{ cancelBtnText }}
        </PrimaryButton>
      </div>
    </div>
  </CustomDialog>
</template>
<script setup lang="ts">
import CustomDialog from "~/components/shared/custom-dialog/CustomDialog.vue";
import PrimaryButton from "~/components/shared/primary-button/PrimaryButton.vue";
defineProps<{
  titleText: string;
  descriptionText: string;
  cookieSettingsLinkText: string;
  confirmBtnText: string;
  cancelBtnText: string;
}>();
const emit = defineEmits<{
  close: [];
  declineChat: [];
  confirmChat: [];
  openCookieSettings: [];
}>();
const manageClick = () => {
  emit("openCookieSettings");
  emit("close");
};
</script>
